import api from "./api";

const notificationService = {
  // POST /admin/notification/send-notification - send notification
  sendNotification: (payload) => api.post('/admin/notification/send-notification', payload),

  // Upload image for notification payload
  // Content-Type must be unset (not 'multipart/form-data') so axios skips its
  // JSON-stringify-FormData path and the browser can attach the multipart boundary itself.
  uploadNotificationImage: (formData) =>
    api.post('/admin/upload/image', formData, {
      headers: {
        'Content-Type': undefined,
      },
      timeout: 30000,
    }),
};

export default notificationService;


